import React from 'react';
import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import './Supports.css';

import { SuppTouchLcm10 } from "../assets/SupportsData";
import { SuppTouchLcm12 } from "../assets/SupportsData";
import { SuppTouchLcm15 } from "../assets/SupportsData";
import { SuppTouchLcm18 } from "../assets/SupportsData";
import { SuppTouchLcm21 } from "../assets/SupportsData";

import SuppTouchLcm101Img from '../images/SupportImg/SuppTouchLcm101.jpg';
import SuppTouchLcm123Img from '../images/SupportImg/SuppTouchLcm123.jpg';
import SuppTouchLcm156Img from '../images/SupportImg/SuppTouchLcm156.jpg';
import SuppTouchLcm185Img from '../images/SupportImg/SuppTouchLcm185.jpg';
import SuppTouchLcm215Img from '../images/SupportImg/SuppTouchLcm215.jpg';

function SuportTouchLcm() {
  // console.log("get into SuppTouchLcm()");
  return (

    //   </Container>
    // </header>
    <div className='supporttouchlcm-page'>
      <header className='mt-5'>
        <Container className='h-100 d-flex align-items-center justify-content-center'>
          <h1 className='text-light'>Support / Touch LCM</h1>
        </Container>
      </header>

      <section id='supptouchlcm10' className='supptouchlcm bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Touch LCM 10 inch</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              {/* <Col lg={6} className='d-flex'> */}
              <img style={{ height: '50vh' }} src={SuppTouchLcm101Img} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-evenly'>
              {/* <Col lg={6} className='d-flex flex-column justify-content-around'> */}
              {SuppTouchLcm10.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchlcm12' className='supptouchlcm bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Touch LCM 12 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchLcm12.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {touchlcm.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-primary'> {touchlcm.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppTouchLcm123Img} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchlcm15' className='supptouchlcm bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Touch LCM 15 inch</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppTouchLcm156Img} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchLcm15.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchlcm18' className='supptouchlcm bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Touch LCM 18 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchLcm18.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {touchlcm.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-primary'> {touchlcm.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppTouchLcm185Img} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section>

      <section id='supptouchlcm21' className='supptouchlcm bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Touch LCM 21 inch</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppTouchLcm215Img} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppTouchLcm21.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default SuportTouchLcm;